import React from 'react';
import PropTypes from 'prop-types';
import styles from './KiCardFilters.theme.scss';
import {dateToShortDate} from 'ki-common/utils/dateHelpers';
import Select from 'react-select';
import KiDatePicker from 'components/KiDatePicker';

function KiCardDebtFilters(props) {
	const {
		fundingVehicle,
		fundingVehicles,
		statementDate,
		setFundingVehicle,
		setStatementDate,
		isFundingVehicleSelectClearable,
		setScenarioId,
		scenarioList,
		scenarioId,
	} = props;

	return (
		<section className={styles.cardFilters}>
			<div className={styles.double}>
				<span className="form-instruction">Display Type:</span>
				<Select
					classNamePrefix="aut-select"
					value={{
						label: 'Data',
						value: 'data',
						type: 'data',
					}}
					isClearable={false}
					options={[
						{
							label: 'Data',
							value: 'data',
							type: 'data',
						},
					]}
				/>
			</div>
			<div className={styles.single}>
				<span className="form-instruction">Statement Date</span>
				<KiDatePicker
					className={styles.filterDatePicker}
					value={statementDate}
					onChange={val => setStatementDate(dateToShortDate(val))}
				/>
			</div>
			<div className={styles.double}>
				<span className="form-instruction">Funding Vehicle</span>
				<Select
					classNamePrefix="aut-select"
					isClearable={isFundingVehicleSelectClearable}
					isSearchable={true}
					options={fundingVehicles}
					value={fundingVehicle}
					getOptionLabel={option => option.name}
					getOptionValue={option => option._id}
					onChange={option => setFundingVehicle(option)}
				/>
			</div>
			<div className={styles.double}>
				<span className="form-instruction">Scenario Context</span>
				<Select
					classNamePrefix="aut-select"
					isClearable={true}
					isSearchable={true}
					options={scenarioList}
					value={scenarioId}
					getOptionLabel={option => option.label}
					getOptionValue={option => option.value}
					onChange={option => setScenarioId(option)}
				/>
			</div>
		</section>
	);
}

KiCardDebtFilters.propTypes = {
	fundingVehicles: PropTypes.array,
	fundingVehicle: PropTypes.object,
	statementDate: PropTypes.string,
	setFundingVehicle: PropTypes.func,
	setStatementDate: PropTypes.func,
	isFundingVehicleSelectClearable: PropTypes.bool,
	scenarioList: PropTypes.array,
	scenarioId: PropTypes.object,
	setScenarioId: PropTypes.func,
};

KiCardDebtFilters.defaultProps = {
	statementDate: dateToShortDate(new Date()),
	isFundingVehicleSelectClearable: false,
	scenarioList: [],
};

export default KiCardDebtFilters;
